// FYI: this file is imported by host
// adding app imports here could break the host build
// use types.ts instead for app things

export enum ReportSpecVersion {
  V0, // pre-panelbank
  Panelbank,
  FirstClassText,
  FirstClassTextConverted,
  AddPanelIds,
  SlateReport,
}
